import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26 8.6 20.4 3A3.7 3.7 0 0 0 18 2H7a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V11a3.7 3.7 0 0 0-1-2.4m-7-4.2 5.6 5.6H19zM25 28H7V4h10v7a1 1 0 0 0 1 1h7z"
    />
    <path
      fill="currentColor"
      d="M17 16a1 1 0 0 1-1 1h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1m6 8a1 1 0 0 1-1 1H10a1 1 0 0 1 0-2h12a1 1 0 0 1 1 1m0-4a1 1 0 0 1-1 1H10a1 1 0 0 1 0-2h12a1 1 0 0 1 1 1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFileOutlineSVG);
ForwardRef.displayName = "IconFileOutline";
export { ForwardRef as IconFileOutline };
